class Theme {
    constructor({ fontFamilies, fontSizes, fontWeights, lineHeights, breakpoints, components, typography, cssVariables, text, icon, background, surface, shape, categorical }) {
        this.fontFamilies = fontFamilies;
        this.fontSizes = fontSizes;
        this.fontWeights = fontWeights;
        this.lineHeights = lineHeights;
        this.breakpoints = breakpoints;
        this.components = components;
        this.typography = typography;
        this.cssVariables = cssVariables;
        this.text = text;
        this.icon = icon;
        this.background = background;
        this.surface = surface;
        this.shape = shape;
        this.categorical = categorical;
    }
}

export default Theme;
